export default {
  CASES_TABLE: {
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'An error occurred while loading cases!',
      ERROR_WHILE_LOADING_PARTNERS: 'An error occurred while loading partners!',
      ERROR_WHILE_LOADING_STATES: 'An error occurred while loading states!',
    },
    FILTERS: {
      APPLY: 'Apply',
      STAGE_LABEL: 'Main status',
      CASE_ID: {
        LABEL: 'Case ID',
        PLACEHOLDER: 'Start typing...'
      },
      DEBTOR_NAME: {
        LABEL: 'Debtor',
        PLACEHOLDER: 'Start typing...'
      },
      CLIENT: {
        LABEL: 'Client',
        PLACEHOLDER: 'Start typing...',
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Start typing...',
      },
      PRODUCT: {
        LABEL: 'Product',
        PLACEHOLDER: 'Select product...',
        NOTICE: 'Payment Notice',
        DEMAND_LETTER: 'Demand Letter',
        HARD_1: 'Payment Order',
        HARD_2: 'Payment Order - Execution',
      },
      STAGE: {
        DRAFT: 'Draft',
        ONGOING: 'Ongoing',
        CLOSED: 'Closed',
      },
      STATE: {
        LABEL: 'State',
        PLACEHOLDER: 'Start typing...',
      },
      STARTED_AT: {
        LABEL: 'Start date',
        MIN_LABEL: 'Start date (from)',
        MAX_LABEL: 'Start date (to)',
      },
    },
    TABLE_INFO: {
      CLOSED: 'Closed cases',
      CLOSED_INFO:
        'These are cases that have either been successfully paid or closed for other reasons.',
      DRAFT: 'Drafts',
      DRAFT_INFO:
        'These are cases that you paused. If you arrived here by clicking the "Lawyer and Legal Solutions" link from your Számlázz.hu account on a Számlázz.hu invoice, each click created a draft.',
      ONGOING: 'Ongoing cases',
      ONGOING_INFO:
        'These are cases that have been successfully initiated and are currently in progress. If you have any tasks for any of them, we will notify you by email.',
    },
    HEADERS: {
      CASE_ID: 'Case ID',
      REMAINING_CLAIMS: 'Remaining Claims',
      ORIGINAL_CLAIMS: 'Original Claims',
      PARTIES: 'Parties',
      STATE: 'State',
      STARTED_AT: 'Started at',
      LAST_EVENT: 'Last event',
      DEADLINE: 'Deadline',
    },
    MORE_CURRENCIES: '+{{count}} more',
    CASE_ACTIONS: {
      DELETE: 'Delete case',
      EDIT: 'Edit case',
      NO_ACTIONS: 'No available actions',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Details',
      EVENTS_LABEL: 'Events',
    },
    NO_CASES: {
      TITLE: 'No cases found with the given criteria',
    },
  },
};
